import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getNotDependents, showDependents, showProfileUser, showUser } from '../../../../../../redux/actions/users'
import { IRootState } from '../../../../../../redux/types'

export default function UseUserDetailState(userId: number | null) {
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])

  const { error, reload } = useSelector((state: IRootState) => state.user)

  const clientTypes = [
    t('admin.people.esthetic-professional'),
    t('admin.people.final-audience'),
    t('admin.people.esthetic-academy-student'),
    t('admin.people.esthetic-academy-professor')
  ]

  useEffect(() => {
    if (reload && !error) {
      if (userId) {
        dispatch(showProfileUser(userId))
        dispatch(showDependents(userId))
        dispatch(getNotDependents(userId))
      }
    }
  }, [reload])

  const handleClickEdit = () => {
    if (userId) dispatch(showUser(userId))
  }

  return { clientTypes, handleClickEdit }
}
